import { AsyncRouteProps, asyncComponent } from "@jaredpalmer/after"

const routes: AsyncRouteProps<any>[] = [
	{
		path: "/",
		exact: true,
		component: asyncComponent({
			loader: () => import(`pages/Home`),
		}),
	},
	{
		path: "/product/:name",
		component: asyncComponent({
			loader: () => import(`pages/ProductDetail`),
		}),
	},
	{
		path: "/cart",
		component: asyncComponent({
			loader: () => import(`pages/Cart`),
		}),
	},
	{
		path: "/login/:targetUrl?",
		component: asyncComponent({
			loader: () => import(`pages/Login`),
		}),
	},
	{
		path: "/signup/:targetUrl?",
		component: asyncComponent({
			loader: () => import(`pages/Signup`),
		}),
	},
	{
		path: "/shop/business",
		exact: true,
		component: asyncComponent({
			loader: () => import(`pages/Business`),
		}),
	},
	{
		path: "/shop/:filter([A-Za-z-.]+)",
		exact: true,
		component: asyncComponent({
			loader: () => import(`pages/Shop`),
		}),
	},
	{
		path: "/shop/:page([0-9]+)?",
		exact: true,
		component: asyncComponent({
			loader: () => import(`pages/Shop`),
		}),
	},
	{
		path: "/blog/:page([0-9]+)?",
		exact: true,
		component: asyncComponent({
			loader: () => import(`pages/Blog`),
		}),
	},
	{
		path: "/post/:slug",
		component: asyncComponent({
			loader: () => import(`pages/Post`),
		}),
	},
	{
		path: "/download-center",
		component: asyncComponent({
			loader: () => import(`pages/DownloadCenter`),
		}),
	},
	{
		exact: true,
		path: "/dashboard",
		component: asyncComponent({
			loader: () => import(`pages/Dashboard`),
		}),
	},
	{
		path: "/profile/edit",
		component: asyncComponent({
			loader: () => import(`pages/Profile`),
		}),
	},
	{
		path: "/profile/legal",
		component: asyncComponent({
			loader: () => import(`pages/Legal`),
		}),
	},
	{
		path: "/profile/change-password",
		component: asyncComponent({
			loader: () => import(`pages/ChangePassword`),
		}),
	},
	{
		path: "/dashboard/my-orders",
		component: asyncComponent({
			loader: () => import(`pages/Orders`),
		}),
	},
	{
		path: "/logout",
		component: asyncComponent({
			loader: () => import(`pages/Logout`),
		}),
	},
	{
		path: "/about-us",
		component: asyncComponent({
			loader: () => import(`pages/About`),
		}),
	},
	{
		path: "/contact-us",
		component: asyncComponent({
			loader: () => import(`pages/Contact`),
		}),
	},
	{
		path: "/forget-password/:email?",
		component: asyncComponent({
			loader: () => import(`pages/ForgetPassword`),
		}),
	},
	{
		path: "/terms-conditions",
		component: asyncComponent({
			loader: () => import(`pages/Terms`),
		}),
	},
	{
		path: "/help",
		component: asyncComponent({
			loader: () => import(`pages/Help`),
		}),
	},
	{
		path: "/faq",
		component: asyncComponent({
			loader: () => import(`pages/FAQ`),
		}),
	},
	{
		path: "/search/:q",
		component: asyncComponent({
			loader: () => import(`pages/Search`),
		}),
	},
	{
		path: "/transaction/:id",
		component: asyncComponent({
			loader: () => import(`pages/Transaction`),
		}),
	},
	{
		component: asyncComponent({
			loader: () => import(`pages/Notfound`),
		}),
	},
]

export default routes
